/* eslint
    no-unused-expressions: "warn"
*/

import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';

namespace Easyfy.Modules {
  @invoke
  class Accordion {

    onInit() {
      globalEvent({
        type: 'click',
        events: [
          {
            callback: (e) => {
              Accordion.OnOpenAccordion;
            }
          },
          {
            event: 'toggle-accordion',
            callback: Accordion.OnOpenAccordion
          }
        ]
      });
    }

    static OnOpenAccordion(e) {
      const element = (e.target as HTMLElement).closest(
        'details'
      ) as HTMLDetailsElement;
      const id = element.attributes['data-accordion']?.value;

      if (!element.open) {
        document
          .querySelectorAll(`details[data-accordion="${id}"]`)
          .forEach((detail) => {
            if ((detail as HTMLDetailsElement).open) {
              detail.removeAttribute('open');
            }
          });
      }
    }
  }
}
